export default __webpack_public_path__ + "img/products.hero.asset.cfa0d4b7.jpg";